// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__1HBNf","gfeWrapper":"CalendarEvent_gfeWrapper__3MOls"};